import { render } from "./DetailEmployee.vue?vue&type=template&id=4831ebd4&scoped=true"
import script from "./DetailEmployee.vue?vue&type=script&lang=js"
export * from "./DetailEmployee.vue?vue&type=script&lang=js"

import "./DetailEmployee.vue?vue&type=style&index=0&id=4831ebd4&scoped=true&lang=css"
import "./DetailEmployee.vue?vue&type=style&index=1&id=4831ebd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4831ebd4"]])

export default __exports__